import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationCount } from '../../hooks/useNotificationCount';
import { usePopup } from '../../contexts/PopupContext';
import { FriendsNavIcon, SettingsNavIcon } from './NavOptionIcons';
import './NavigationLinks.css';

function NavigationLinks({ activeTab, setActiveTab, onLogout, accountRestricted = false }) {
  const { t } = useTranslation('shared');
  const { count: notificationCount } = useNotificationCount();
  const { openPopup } = usePopup();

  const handleTabChange = (tabId) => {
    if (accountRestricted) return;
    if (setActiveTab) {
      setActiveTab(tabId);
    }
  };

  const handleSettingsClick = () => {
    openPopup('settings', { onLogout }, 0);
  };

  const handleFriendsClick = () => {
    openPopup('friends-management', {}, 0);
  };

  const tabs = [
    { id: 'discover', label: t('navigation.discover', 'Discover') },
    { id: 'events', label: t('navigation.events', 'My Events') },
    { id: 'notifications', label: t('navigation.notifications', 'Notifications'), badge: notificationCount },
    { id: 'profile', label: t('navigation.profile', 'Profile') },
  ];

  const options = accountRestricted
    ? [
        {
          id: 'settings',
          label: t('navigation.settings', 'Settings'),
          onClick: handleSettingsClick,
          Icon: SettingsNavIcon,
        },
      ]
    : [
        {
          id: 'friends',
          label: t('navigation.friends', 'My Friends'),
          onClick: handleFriendsClick,
          Icon: FriendsNavIcon,
        },
        {
          id: 'settings',
          label: t('navigation.settings', 'Settings'),
          onClick: handleSettingsClick,
          Icon: SettingsNavIcon,
        },
      ];

  return (
    <div className="navigation-links-wrapper">
      {!accountRestricted && (
        <div className="navigation-menu">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'nav-tab--active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
            >
              <span className="nav-tab-label">{tab.label}</span>
              {tab.badge !== undefined && tab.badge > 0 && (
                <span className="nav-tab-badge">{tab.badge > 99 ? '99+' : tab.badge}</span>
              )}
            </button>
          ))}
        </div>
      )}

      <div className="navigation-options">
        {options.map((option) => (
          <button
            key={option.id}
            type="button"
            className="nav-tab nav-tab--icon nav-tab--option"
            onClick={option.onClick}
            aria-label={option.label}
            title={option.label}
          >
            <option.Icon />
          </button>
        ))}
      </div>
    </div>
  );
}

export default NavigationLinks;
